import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Get Subtitle Themes
  subtitleThemesRequest: ['callback'],
  subtitleThemesSuccess: ['themes'],
  subtitleThemesFailure: ['error'],

  // Transcribe Audio (Whisper)
  subtitleTranscribeRequest: ['audioId', 'callback'],
  subtitleTranscribeSuccess: ['data'],
  subtitleTranscribeFailure: ['error'],

  // Regenerate Subtitles with Theme
  subtitleRegenerateRequest: ['audioId', 'style', 'callback'],
  subtitleRegenerateSuccess: ['data'],
  subtitleRegenerateFailure: ['error'],

  // Set selected theme
  setSubtitleTheme: ['themeId'],

  // Reset
  subtitleReset: [],
})

export const SubtitleTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Themes
  themes: [],
  themesFetching: false,
  themesError: null,

  // Transcribe
  transcribing: false,
  transcribeError: null,

  // Regenerate
  regenerating: false,
  regenerateError: null,

  // Selected theme
  selectedTheme: 'default',
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Themes
    case Types.SUBTITLE_THEMES_REQUEST:
      return { ...state, themesFetching: true, themesError: null }
    case Types.SUBTITLE_THEMES_SUCCESS:
      return { ...state, themes: action.themes, themesFetching: false, themesError: null }
    case Types.SUBTITLE_THEMES_FAILURE:
      return { ...state, themesFetching: false, themesError: action.error }

    // Transcribe
    case Types.SUBTITLE_TRANSCRIBE_REQUEST:
      return { ...state, transcribing: true, transcribeError: null }
    case Types.SUBTITLE_TRANSCRIBE_SUCCESS:
      return { ...state, transcribing: false, transcribeError: null }
    case Types.SUBTITLE_TRANSCRIBE_FAILURE:
      return { ...state, transcribing: false, transcribeError: action.error }

    // Regenerate
    case Types.SUBTITLE_REGENERATE_REQUEST:
      return { ...state, regenerating: true, regenerateError: null }
    case Types.SUBTITLE_REGENERATE_SUCCESS:
      return { ...state, regenerating: false, regenerateError: null }
    case Types.SUBTITLE_REGENERATE_FAILURE:
      return { ...state, regenerating: false, regenerateError: action.error }

    // Selected theme
    case Types.SET_SUBTITLE_THEME:
      return { ...state, selectedTheme: action.themeId }

    // Reset
    case Types.SUBTITLE_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
